import { getValue } from '@kundinos/nanostores';

import { modalsStore } from './stores';

import type { ModalId } from './typings';

/**
 * Closes only specified modal window
 * @param id - identifier of modal window, that need close
 */
async function close(id: ModalId): Promise<void> {
  const modals = getValue(modalsStore);
  const newStack = [...modals.stack];
  const selectedModalIndex = newStack.findIndex((modal) => modal.id === id);
  const prevModalIndex = selectedModalIndex - 1;

  if (newStack[selectedModalIndex]) {
    newStack[selectedModalIndex].visible = false;
  }

  if (prevModalIndex >= 0 && !newStack[prevModalIndex]?.hidden) {
    newStack[prevModalIndex].visible = true;

    //Переносим предпоследний элемент из стека в конец списка
    const prevPosition = newStack.splice(selectedModalIndex, 1, newStack[prevModalIndex])[0];
    newStack.splice(prevModalIndex, 1, prevPosition);
  }

  modalsStore.set({
    ...modals,
    stack: newStack,
  });

  return new Promise((resolve) => {
    setTimeout(() => {
      modalsStore.set({
        ...modals,
        stack: newStack.filter((modal) => modal.id !== id),
      });

      window.history.replaceState({}, null, `${location.pathname}${location.search}`);

      resolve();
    }, modals.timeout);
  });
}

export default close;
